import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import { ArrowLeftIcon, Lock01Icon } from '@untitledui-icons/react/line'
import { Logo } from '@/components/layout/Logo'

export function ForbiddenPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-cream px-4 dark:bg-gray-950">
      <div className="mb-8">
        <Logo width={140} />
      </div>
      
      <div className="text-center">
        <div className="mb-6 flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-error-100 dark:bg-error-900/30">
            <Lock01Icon className="h-8 w-8 text-error-600 dark:text-error-400" />
          </div>
        </div>
        
        <p className="mb-2 text-sm font-semibold text-error-600 dark:text-error-400">
          {t('errors.error_403')}
        </p>
        <h1 className="mb-4 text-4xl font-bold text-gray-900 dark:text-white sm:text-5xl">
          {t('errors.access_denied')}
        </h1>
        <p className="mb-8 max-w-md text-lg text-gray-500 dark:text-gray-400">
          {t('errors.access_denied_description')}
        </p>
        
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <button
            onClick={() => navigate(-1)}
            className="
              inline-flex items-center gap-2 rounded-lg
              border border-gray-300 bg-white px-4 py-2.5
              text-sm font-semibold text-gray-700
              transition-colors hover:bg-gray-50
              focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2
              dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700
            "
          >
            <ArrowLeftIcon className="h-4 w-4" />
            {t('errors.go_back')}
          </button>
          <Link
            to="/dashboard"
            className="
              inline-flex items-center gap-2 rounded-lg
              bg-brand-500 px-4 py-2.5 text-sm font-semibold text-white
              transition-colors hover:bg-brand-600
              focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2
            "
          >
            {t('errors.go_home')}
          </Link>
        </div>
      </div>
    </div>
  )
}

export default ForbiddenPage
